module.exports = __webpack_public_path__ + "static/media/take-challenge-popup-footer.fdc82cc7.png";